module.exports = __webpack_public_path__ + "img/ic_bath.c39624c2.svg";